import { UseFormRegister } from 'react-hook-form';

import FileUpload from 'src/components/FileUpload/FileUpload';
import InputText from 'src/components/InputText/InputText';

import { UpdateChildFormData } from '@/pages/mypage';
import { Child } from '@/types/child';

type Props = {
  child: Child | undefined;
  register: UseFormRegister<UpdateChildFormData>;
  setRehabilitationCertificateFile: (v: File | undefined) => void;
};

const OtherForm = ({ child, register, setRehabilitationCertificateFile }: Props) => {
  return (
    <div className="space-y-4 p-4">
      <div className="space-y-4">
        <div className="text-base font-bold">療育手帳</div>
        <FileUpload
          canPreview
          canDelete
          buttonText="画像アップロード"
          accept="image/*"
          setFile={setRehabilitationCertificateFile}
          initialValue={child?.rehabilitation_certificate_image_url || ''}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">障がい内容</div>
        <div className="text-base">
          {child?.disability_details ? child.disability_details : '記入なし'}
        </div>
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">アレルギー等</div>
        <InputText
          type="text"
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          {...register('allergies')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">実習先</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('trainingLocation')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">備考</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="textarea"
          {...register('notes')}
        />
        <hr className="border-gray-400" />
      </div>
    </div>
  );
};

export default OtherForm;
